import { render, staticRenderFns } from "./Metaverse.vue?vue&type=template&id=13f6da5c"
import script from "./Metaverse.vue?vue&type=script&lang=js"
export * from "./Metaverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports